import { render, staticRenderFns } from "./VideosCreate.vue?vue&type=template&id=1f247eb6&"
import script from "./VideosCreate.vue?vue&type=script&lang=js&"
export * from "./VideosCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports